<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Andrew Marriott was an army officer for over thirty years, 
seeing service in conflicts in Europe, the Middle East and West 
Africa. He received a commendation for devotion to duty as a 
platoon commander in Northern Ireland and was later awarded 
an MBE. He has since become an archaeologist and, after taking 
degrees at the University of York, in 2018, he was awarded a 
doctorate by Newcastle University.
<br/><br/> 
He is married with two daughters and lives in North Yorkshire. </p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?45d02ae2